import { render, staticRenderFns } from "./DocumentsPage.vue?vue&type=template&id=00c1700e"
import script from "./DocumentsPage.vue?vue&type=script&lang=js"
export * from "./DocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentsPage.vue?vue&type=style&index=0&id=00c1700e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports